import React, { Component } from "react";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import ItemTypes from "./ItemTypes";

const cardTarget = {
  drop(props, monitor, component) {
    if (monitor.getItem().type === "search-card") {
      props.addTargetItem(monitor.getItem().target, props.indexa);
      monitor.getItem().type = "card";
      monitor.getItem().indexa = props.indexa;
      monitor.getItem().indexb = 0;
      props.setDragging(monitor.getItem().id, props.indexa, 0, true);
    } else {
      const dragIndexa = monitor.getItem().indexa;
      const dragIndexb = monitor.getItem().indexb;
      const hoverIndexa = props.indexa;
      const hoverIndexb = 0;

      // Don't replace items with themselves
      if (dragIndexa === hoverIndexa && dragIndexb === hoverIndexb) {
        return;
      }

      // Time to actually perform the action
      props.setDragging(monitor.getItem().id, hoverIndexa, hoverIndexb, null);
      props.moveTargetItem(dragIndexa, dragIndexb, hoverIndexa, hoverIndexb);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      monitor.getItem().indexa = hoverIndexa;
      monitor.getItem().indexb = hoverIndexb;
    }
    props.cleanTargets();
  }
};

const drop = () =>
  DropTarget(
    [ItemTypes.CARD, ItemTypes.SEARCHCARD],
    cardTarget,
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver()
    })
  );
class AndTarget extends Component {
  static propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    indexa: PropTypes.number.isRequired
  };

  render() {
    const { connectDropTarget } = this.props;
    const clsName = ["connector__target"];
    if (this.props.isOver) {
      clsName.push("connector__target--hovered");
    }
    if (this.props.dragging) {
      return (
        <div>
          <div className="results__connector"><p>AND</p></div>
          {connectDropTarget(<div className={clsName.join(" ")} />)}
        </div>
      );
    } else {
      return null;
    }
  }
}
export default drop()(AndTarget);



// WEBPACK FOOTER //
// ./src/components/AndTarget.js